import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import styles from './styles.css'

class Switch extends Component {
  static propTypes = {
    className: PropTypes.string,
    type: PropTypes.oneOf(['checkbox', 'radio']).isRequired,
    label: PropTypes.node,
    input: PropTypes.object,
    meta: PropTypes.object,
    description: PropTypes.node,
  }

  static defaultProps = {
    className: '',
    label: null,
    description: null,
    input: {},
    meta: {},
  }

  getClassName() {
    const { meta, input } = this.props

    return classnames(
      styles.root,
      styles[this.props.type],
      {
        [styles.focused]: meta.active,
        [styles.faulty]: meta.touched && meta.error,
        [styles.checked]: input.checked,
        [styles.required]: this.props.required, // eslint-disable-line react/prop-types
        [styles.disabled]: this.props.disabled, // eslint-disable-line react/prop-types
      },
      this.props.className,
    )
  }

  render() {
    const {
      className,
      label,
      description,
      input,
      meta,

      ...restProps
    } = this.props

    return (
      <React.Fragment>
        <label className={this.getClassName()}>
          <input {...input} {...restProps} className={styles.input} />

          <span className={styles.fakeInput} />

          {label && <div className={styles.label}>{label}</div>}

          {meta.touched &&
            meta.error && <div className={styles.error}>{meta.error}</div>}
        </label>
        {description && <div className={styles.description}>{description}</div>}
      </React.Fragment>
    )
  }
}

export default Switch



// WEBPACK FOOTER //
// ../source/components/Switch/index.js